import { render, staticRenderFns } from "./Meals.vue?vue&type=template&id=50e0394a"
import script from "./Meals.vue?vue&type=script&lang=js"
export * from "./Meals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports